import axios from 'axios';
import { getCookies,removeCookies } from '@/utils/auth';
// import { Toast } from 'vant';
// import errorCode from '@/utils/errorCode';
// import { tansParams, blobValidate } from '@/utils/ruoyi';
import router from '@/router'
import cache from '@/utils/cache';
import { showToast,showLoadingToast,closeToast } from 'vant';
// import useUserStore from '@/store/modules/user';

// let loadingInstance;
// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: `/prod-api`, //import.meta.env.VITE_APP_BASE_API,
  // 超时
  timeout: 60000,
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
    if (getCookies('weToken')) {
      config.headers['Authorization'] = 'Bearer ' + getCookies('weToken'); // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers['clientid'] = getCookies('clientId');
    }
    // 修改Content-Type
    if (config.contentType) {
      config.headers['Content-Type'] = config.contentType;
    }
    if (!config.settings?.isLoad) {
      showLoadingToast({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
        loadingType: 'spinner',
      });
    }
    
    if (
      !isRepeatSubmit &&
      (config.method === 'post' || config.method === 'put')
    ) {
      const requestObj = {
        url: config.url,
        data:
          typeof config.data === 'object'
            ? JSON.stringify(config.data)
            : config.data,
        time: new Date().getTime(),
      };
      const sessionObj = cache.session.getJSON('sessionObj');
      if (
        sessionObj === undefined ||
        sessionObj === null ||
        sessionObj === ''
      ) {
        cache.session.setJSON('sessionObj', requestObj);
      } else {
        const s_url = sessionObj.url; // 请求地址
        const s_data = sessionObj.data; // 请求数据
        const s_time = sessionObj.time; // 请求时间
        const interval = 10; // 间隔时间(ms)，小于此时间视为重复提交
        if (
          !config.repeatType &&
          s_data === requestObj.data &&
          requestObj.time - s_time < interval &&
          s_url === requestObj.url
        ) {
          const message = '数据正在处理，请勿重复提交';
          console.warn(`[${s_url}]: ` + message);
          return Promise.reject(new Error(message));
        } else {
          cache.session.setJSON('sessionObj', requestObj);
        }
      }
    }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    
    // 未设置状态码则默认成功状态
    const code = res?.data?.code || 200;
    // 获取错误信息
    const msg = res?.data?.msg;
    closeToast();//关闭加载框
    console.log('res===',res,code)
    if (code !== 200 && code != 1) {
      console.log('code',code)
      if (code == 401) {
       removeCookies('weToken') 
       showToast('token已过期,请重新登陆！');
       router.push({ path: '/weLogin' })
      }else{
        showToast(msg);
      }
      return Promise.reject(msg);
    } else {
      console.log('res.data',res.data)
      return Promise.resolve(res.data);
    }
  },
  (error) => {
    console.log('err' + error);
    let { message } = error;
    if (message == 'Network Error') {
      message = '网络接口连接异常';
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时';
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常';
    }
    showToast(message);
    return Promise.reject(error);
  }
);

export default service;
